"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _query = _interopRequireDefault(require("./query.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function formatDcwLabel(questProject, assignment, deployment) {
  return questProject + ' 〉' + assignment + ' 〉' + deployment;
}
var usersLogTable = function usersLogTable() {
  var view = {
    query: _query["default"],
    rowKey: 'username',
    isAscentOrder: true,
    handle: 'usersLog',
    columns: [{
      name: 'username',
      label: 'Username',
      filter: true,
      sort: true
    }, {
      name: 'firstName',
      label: 'First Name',
      filter: true,
      sort: true
    }, {
      name: 'lastName',
      label: 'Last Name',
      filter: true,
      sort: true
    }, {
      name: 'email',
      label: 'Email',
      filter: true,
      sort: true
    }, {
      name: 'lastLoginAt',
      label: 'Last Login',
      filter: true,
      sort: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'pawns',
      label: 'Pawns',
      filter: false,
      sort: false,
      render: function render(_ref) {
        var value = _ref.value,
          row = _ref.row,
          isCsv = _ref.isCsv;
        var pawns = row.pawnList.map(function (p) {
          return p.pawn.label + (p.pawn.archived ? ' (ARCHIVED)' : '');
        });
        if (isCsv) {
          return pawns.join();
        }
        return pawns.map(function (p, index) {
          return /*#__PURE__*/_react["default"].createElement("ul", {
            style: {
              paddingLeft: '1.0em'
            },
            key: index
          }, /*#__PURE__*/_react["default"].createElement("li", null, p));
        });
      }
    }, {
      name: 'metrics',
      label: 'Data Collection Waves',
      filter: false,
      sort: false,
      render: function render(_ref2) {
        var value = _ref2.value,
          row = _ref2.row,
          isCsv = _ref2.isCsv;
        // use object instead of array to prevent duplicates more efficiently
        var deployments = {};
        row.pawnList.forEach(function (p) {
          // if they have progress
          p.assignmentProgressList.forEach(function (ap) {
            if (ap.assignment.group.group.groupId && ap.assignment.assignmentId) {
              deployments[formatDcwLabel(ap.assignment.group.group.label, ap.assignment.label, ap.deployment.label)] = true;
            }
          });

          // or if they're Known Respondents who don't have progress
          p.respondentList.forEach(function (respondent) {
            var _respondent$deploymen, _respondent$deploymen2, _respondent$deploymen3, _respondent$deploymen4, _respondent$deploymen5, _respondent$deploymen6;
            if (respondent !== null && respondent !== void 0 && (_respondent$deploymen = respondent.deployment) !== null && _respondent$deploymen !== void 0 && (_respondent$deploymen2 = _respondent$deploymen.assignment) !== null && _respondent$deploymen2 !== void 0 && _respondent$deploymen2.assignmentId && respondent !== null && respondent !== void 0 && (_respondent$deploymen3 = respondent.deployment) !== null && _respondent$deploymen3 !== void 0 && (_respondent$deploymen4 = _respondent$deploymen3.assignment) !== null && _respondent$deploymen4 !== void 0 && (_respondent$deploymen5 = _respondent$deploymen4.group) !== null && _respondent$deploymen5 !== void 0 && (_respondent$deploymen6 = _respondent$deploymen5.group) !== null && _respondent$deploymen6 !== void 0 && _respondent$deploymen6.groupId) {
              deployments[formatDcwLabel(respondent.deployment.assignment.group.group.label, respondent.deployment.assignment.label, respondent.deployment.label)] = true;
            }
          });
        });
        var deploymentsAsArray = Object.keys(deployments);
        if (isCsv) {
          return deploymentsAsArray.join();
        }
        return deploymentsAsArray.map(function (d, index) {
          return /*#__PURE__*/_react["default"].createElement("ul", {
            style: {
              paddingLeft: '1.0em'
            },
            key: index
          }, /*#__PURE__*/_react["default"].createElement("li", null, d));
        });
      }
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "usersLog",
    saveState: true,
    views: [{
      handle: 'usersLog',
      title: 'Users Log',
      table: view
    }]
  }));
};
var _default = exports["default"] = {
  name: 'userslog',
  title: 'Users Log',
  content: usersLogTable()
};